import useI18n from '@/composables/use-i18n'
import CollectionType from '@/enums/CollectionType'
import { computed, unref } from '@nuxtjs/composition-api'
import useCollectionContext from './use-collection-context'

export type Location = {
  title: string,
  image: string,
  link: string,
  provides: CollectionType[]
}

export type Collection = {
  sort: number,
  title: string,
  locations: Location[]
}

export default function () {
  const i18n = useI18n()
  const { type } = useCollectionContext()

  // 北部
  const northernLocations: Location[] = [
    {
      title: String(i18n.t('city.taipei')),
      image: 'https://cdn.gogoout.com/city/2/20160729184837459.jpg',
      link: '/search/city/TP',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.newTaipei')),
      image: 'https://cdn.gogoout.com/city/3/20160729180912885.png',
      link: '/search/city/NTP',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.taoyuan')),
      image: 'https://cdn.gogoout.com/city/19/20170102164321410.jpg',
      link: '/search/city/TY',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.hsinchu')),
      image: 'https://cdn.gogoout.com/city/5/20180529123232164.jpg',
      link: '/search/city/HCT',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.yilan')),
      image: 'https://cdn.gogoout.com/city/19/20170102164321410.jpg',
      link: '/search/city/LD',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
  ]
  const northernCollection: Collection = {
    sort: 1,
    title: String(i18n.t('direction.northern')),
    locations: northernLocations,
  }

  // 東部
  const easternLocations: Location[] = [
    {
      title: String(i18n.t('city.hualien')),
      image: 'https://cdn.gogoout.com/city/18/20161202183429808.jpg',
      link: '/search/city/HL',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.taitung')),
      image: 'https://cdn.gogoout.com/city/17/20170102163224299.JPG',
      link: '/search/city/TT',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
  ]
  const easternCollection: Collection = {
    sort: 4,
    title: String(i18n.t('direction.eastern')),
    locations: easternLocations,
  }

  // 中部
  const centralLocations: Location[] = [
    {
      title: String(i18n.t('city.taichung')),
      image: 'https://cdn.gogoout.com/city/8/20160829145406538.jpg',
      link: '/search/city/TC',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.changhua')),
      image: 'https://cdn.gogoout.com/city/9/20180418170353820.jpg',
      link: '/search/city/CH',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
  ]
  const centralCollection: Collection = {
    sort: 2,
    title: String(i18n.t('direction.central')),
    locations: centralLocations,
  }

  // 南部
  const southernLocations: Location[] = [
    {
      title: String(i18n.t('city.chiayi')),
      image: 'https://cdn.gogoout.com/city/13/20171226140415588.jpg',
      link: '/search/city/CIH',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.tainan')),
      image: 'https://cdn.gogoout.com/city/14/20161031151320569.jpg',
      link: '/search/city/TN',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.kaohsiung')),
      image: 'https://cdn.gogoout.com/city/15/20160826121338351.jpg',
      link: '/search/city/KH',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.pingtung')),
      image: 'https://cdn.gogoout.com/city/16/202006031644.jpg',
      link: '/search/city/PT',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
  ]
  const southernCollection: Collection = {
    sort: 3,
    title: String(i18n.t('direction.southern')),
    locations: southernLocations,
  }

  // 離島
  const islandLocations: Location[] = [
    {
      title: String(i18n.t('city.kinmen')),
      image: 'https://cdn.gogoout.com/city/21/20170320101246067.jpg',
      link: '/search/city/KM',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.penghu')),
      image: 'https://cdn.gogoout.com/city/20/20170925145254792.jpg',
      link: '/search/city/PH',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
    {
      title: String(i18n.t('city.liuqiu')),
      image: 'https://cdn.gogoout.com/city/29/202008171558272.png',
      link: '/search/city/LQ',
      provides: [CollectionType.COMPACT, CollectionType.SPORTS_CAR, CollectionType.WELCAB, CollectionType.MULTI_SEATER, CollectionType.VOLVO, CollectionType.TESLA, CollectionType.RV],
    },
  ]
  const islandCollection: Collection = {
    sort: 5,
    title: String(i18n.t('direction.island')),
    locations: islandLocations,
  }

  const collections = computed(() => {
    const _collections: {[key: string]: Collection} = {
      northernCollection,
      easternCollection,
      centralCollection,
      southernCollection,
      islandCollection,
    }

    if (type.value) {
      for (const key of Object.keys(_collections)) {
        _collections[key].locations = _collections[key].locations.filter(location => location.provides.includes(type.value!))
      }
    }

    return _collections
  })

  return unref(collections)
}
